<template>
  <label class="fs-5 form-label fw-bold" :for="localSlider.id"
    >{{ localSlider.label }} | {{ switchLabelPostfix }}
  </label>

  <div class="row justify-content-center p-3">
    <div v-if="localSlider.id === 'heat'" class="w-100">
      <input
        class="form-range"
        :type="localSlider.type"
        :id="localSlider.id"
        v-model="localSlider.value"
        :min="localSlider.min"
        :max="localSlider.max"
        @input="updateSlider"
        :disabled="isDisabled"
        list="tickmarksHeat"
      />

      <!-- Adapted from: https://stackoverflow.com/questions/61204680/html-range-slider-with-labels-every-5 -->
      <datalist
        v-if="localSlider.id === 'heat'"
        class="
          form-range
          d-flex
          justify-content-between
          text-black
          fw-bold
          w-100
        "
        id="tickmarksHeat"
      >
        <option class="fw-bold" value="0" label="Off"></option>
        <option class="fw-bold" value="100" label="On"></option>
      </datalist>
    </div>
    <div v-else class="w-100">
      <input
        class="form-range"
        :type="localSlider.type"
        :id="localSlider.id"
        v-model="localSlider.value"
        step=".05"
        :min="localSlider.min"
        :max="localSlider.max"
        @input="updateSlider"
        :disabled="isDisabled"
        list="tickmarks"
      />
      <datalist
        class="
          form-range
          d-flex
          justify-content-between
          text-black
          fw-bold
          w-100
        "
        id="tickmarks"
      >
        <option class="fw-bold" value="0" label="0"></option>
        <option class="fw-bold" value="0" label="25"></option>
        <option class="fw-bold" value="0" label="50"></option>
        <option class="fw-bold" value="0" label="75"></option>
        <option class="fw-bold" value="100" label="100"></option>
      </datalist>
    </div>
  </div>
</template>

<script>
export default {
  name: "SliderComponent",
  emits: ["update:selectedScenarioSlider"],
  data() {
    return {
      localSlider: { ...this.slider }
    };
  },
  props: {
    slider: {
      type: Object,
      required: true
    },
    isDisabled: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    switchLabelPostfix() {
      const sliderId = this.localSlider.id;
      const valueOfSlider = Number(this.localSlider.value);

      let postFix = "";
      if (sliderId === "light" || sliderId === "mist") {
        postFix = `${Number(valueOfSlider * 100).toPrecision(3)} %`; //* Lets be very "precise" with floating point arithmetic.
      } else if (sliderId === "heat") {
        if (valueOfSlider === 0) {
          postFix = "Off";
        } else if (valueOfSlider === 1) {
          postFix = "On";
        }
      }
      return postFix;
    }
  },

  methods: {
    //* update slider value when localSlider changes
    updateSlider(event) {
      this.localSlider.value = event.target.value;
      this.$emit("update:selectedScenarioSlider", this.localSlider);
    }
  },
  watch: {
    //* watch the slider prop for changes
    slider: {
      handler() {
        this.localSlider = { ...this.slider };
      },
      deep: true
    }
  }
};
</script>
